"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import Image from "next/image";
import popupModel from "@/assets/alfafashionimages/fashion-popup-model.jpeg";
import { isCoolingDown, dispatchCooldown } from "@/lib/popupCooldown";
import "./FashionNewsletterPopup.scss";

const KEY = "fashion_newsletter_popup";

export default function FashionNewsletterPopup() {
  const [visible, setVisible] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    if (isCoolingDown(KEY)) return;
    const timer = setTimeout(() => setVisible(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    dispatchCooldown(KEY);
    setVisible(false);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    setStatus(null);
    try {
      await axios.post(
        process.env.NEXT_PUBLIC_BACKEND + "/storefront/newsletter",
        { email, storefront: process.env.NEXT_PUBLIC_STOREFRONT_ID || "23" }
      );
      setStatus("success");
      setTimeout(dismiss, 1800);
    } catch (err) {
      setStatus(err?.response?.status === 400 ? "already" : "error");
    } finally {
      setLoading(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="fn-popup__overlay">
      <div className="fn-popup__modal" onClick={(e) => e.stopPropagation()}>
        {/* Left: image */}
        <div className="fn-popup__image-panel">
          <Image src={popupModel} alt="Fashion" fill style={{ objectFit: "cover", objectPosition: "center top" }} />
          <button className="fn-popup__close fn-popup__close--mobile" onClick={dismiss} aria-label="Close">×</button>
        </div>

        {/* Right: content */}
        <div className="fn-popup__content-panel">
          <button className="fn-popup__close" onClick={dismiss} aria-label="Close">×</button>
          <div className="fn-popup__body">
            <h2 className="fn-popup__title">Join Our Mailing List</h2>
            <p className="fn-popup__desc">
              Be the first to get updates on our new collections, early delivery pieces and more.
            </p>
            <form onSubmit={handleSubscribe} className="fn-popup__form">
              <input
                type="email"
                className="fn-popup__input"
                placeholder="Your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {status === "success" && <p className="fn-popup__msg fn-popup__msg--success">You&apos;re subscribed!</p>}
              {status === "already" && <p className="fn-popup__msg fn-popup__msg--error">Email already registered.</p>}
              {status === "error"   && <p className="fn-popup__msg fn-popup__msg--error">Something went wrong. Please try again.</p>}
              <button type="submit" className="fn-popup__btn" disabled={loading}>
                {loading ? "SUBSCRIBING..." : "SUBSCRIBE"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
